import {
  Divider,
  Stack,
  Text,
  Container,
  Box,
  HStack,
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Image,
  Heading,
  SimpleGrid,
  Badge,
  Link,
  Center,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { motion } from "framer-motion";
import { useState } from "react";
import useProjectsData from "../data/useProjectsData";
import useOtherProjectsData from "../data/useOtherProjectsData";
import useTagData from "../data/useTagData";

const revealProps = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.45, ease: "easeOut" },
};

export default function Projects() {
    const projects = useProjectsData();
    const others = useOtherProjectsData();
    const options = useTagData("ProjectsTags");
    const mainOptions = [...new Set(projects.flatMap((project) => project.tags || []))].filter(Boolean);
    
    const [selectedMain, setSelectedMain] = useState("All");
    const [selectedOther, setSelectedOther] = useState("All");

    const handleSelectedMain = (value) => {
      setSelectedMain(value);
    };

    const handleSelectedOther = (value) => {
      setSelectedOther(value);
    };
    
  return (
    <>
      <Container id="projects">
        <Stack
          as={Box}
          textAlign={"center"}
          spacing={{ base: 8, md: 14 }}
          pb={{ base: 20, md: 36 }}
        >
          <Stack align="center" direction="row" p={4}>
            <HStack mx={4}>
              <Text as="span" color="brand.400" fontWeight={800}>
                o
              </Text>
              <Text fontFamily="heading" fontSize="sectionHeading" fontWeight={800}>Projects</Text>
            </HStack>
            <Divider orientation="horizontal" />
          </Stack>
          <Center px={4} w="100%">
            <Box maxW="100%" overflowX="auto" px={1}>
              <ButtonGroup variant="outline" flexWrap="nowrap" minW="max-content" whiteSpace="nowrap">
                <Button
                  //colorScheme={selectedMain === "All" ? "brandAccent" : "brand"}
                  //color={selectedMain === "All" ? "brand.300" : "appText"}
                  //borderColor={selectedMain === "All" ? "brandAccent" : "gray.600"}
                  variant="filter"
                  isActive={selectedMain === "All"}
                  onClick={() => handleSelectedMain("All")}
                >
                  All
                </Button>
                {mainOptions.map((option) => (
                  <Button
                    key={option}
                    // colorScheme={selectedMain === option ? "brandAccent" : "brand"}
                    // borderColor={selectedMain === option ? "brandAccent" : "gray.600"}
                    variant="filter"
                    isActive={selectedMain === option}
                    onClick={() => handleSelectedMain(option)}
                  >
                    {option}
                  </Button>
                ))}
              </ButtonGroup>
            </Box>
          </Center>
          <Stack px={4} spacing={4}>
            {projects.filter((project) => {
              if (selectedMain === "All") {
                return true;
              }

              return (project.tags || []).includes(selectedMain);
            }).map((project) => (
              <Box as={motion.div} key={project.name} {...revealProps}>
                <Box id={project.slug}> {/** attach slug for scroll purposes*/}
                <Card
                  direction={{
                    base: "column",
                    md: "row",
                  }}
                  align="stretch"
                  overflow="hidden"
                  //px={{ base: 4, md: 6 }} py={{ base: 3, md: 4 }}
                >
                  {project.image ? (
                    <Image
                      objectFit="cover"
                      src={project.image}
                      alt={project.name}
                      w={{ md: "70%", sm: "100%" }}
                      h="100%"
                    />
                  ) : null} 
                  <Stack h="auto" w="100%"
                  px={{ base: 5, md: 7 }} py={{ base: 4, md: 5 }}>
                    <CardBody align="left" h="auto" w="100%" p={0}>
                      <Stack spacing={4}>
                      <Heading size="md">{project.name}</Heading>

                      <Text py={2}>{project.description}</Text>

                      {/* {project.video ? (
                        <Stack spacing={2} py={2}>
                          <Box
                            as="iframe"
                            src={project.video.embedUrl}
                            title={project.video.text}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            borderRadius="md"
                            width="100%"
                            height="220px"
                          />
                        </Stack>
                      ) : null} */}

                      <HStack flexWrap="wrap" pt={4} spacing={2} justify="flex-end">
                        {project.badges.map((badge) => (
                          <Badge
                            key={badge.text}
                            colorScheme={badge.colorScheme}
                          >
                            {badge.text}
                          </Badge>
                        ))}
                      </HStack>
                      </Stack>
                    </CardBody>
                      <HStack py={2} justify="flex-end">
                        {project.buttons.map((button) => (
                          button.href.startsWith("/") ? (
                            <Button
                              key={button.text}
                              as={RouterLink}
                              to={button.href}
                              color="brand.400"
                            >
                              {button.text}
                            </Button>
                          ) : (
                            <a key={button.text} href={button.href}>
                              <Button color="brand.400">
                                {button.text}
                              </Button>
                            </a>
                          )
                        ))}
                      </HStack>
                  </Stack>
                </Card>
                </Box>
              </Box>
            ))}
          </Stack>
          {others.length > 0?
          <Stack>
            <Text color={"gray.600"} fontSize={"xl"} px={4}>
              Other Projects
            </Text>
            <Center px={4} w="100%">
              <Box maxW="100%" overflowX="auto" px={1}>
                <ButtonGroup variant="outline" flexWrap="nowrap" minW="max-content" whiteSpace="nowrap">
                  <Button
                    colorScheme={selectedOther === "All" ? "brand" : "gray"}
                    onClick={() => handleSelectedOther("All")}
                  >
                    All
                  </Button>
                  {options.map((option) => (
                    <Button
                      key={option.value}
                      colorScheme={selectedOther === option.value ? "brand" : "gray"}
                      onClick={() => handleSelectedOther(option.value)}
                    >
                      {option.value}
                    </Button>
                  ))}
                </ButtonGroup>
              </Box>
            </Center>
            <SimpleGrid columns={[1, 2, 3]} px={4} spacing={4}>
              {others
                .filter((other) => {
                  if (selectedOther === "All") {
                    return true;
                  } else {
                    return other.tags.includes(selectedOther);
                  }
                })
                .map((other) => (
                  <Box as={motion.div} key={other.name} {...revealProps}>
                    <Card>
                      <Stack>
                        <CardBody align="left" h={[null, "40vh"]}>
                          <Heading size="sm">{other.name}</Heading>

                          <Text fontSize="sm" py={2}>
                            {other.description}
                          </Text>

                          <HStack spacing={2}>
                            {other.buttons.map((button) => (
                              <Link
                                key={button.text}
                                href={button.href}
                                color="brand.400"
                              >
                                {button.text}
                              </Link>
                            ))}
                          </HStack>
                          <HStack flexWrap="wrap" pt={4} spacing={2}>
                            {other.badges.map((badge) => (
                              <Badge
                                my={2}
                                key={badge.text}
                                colorScheme={badge.colorScheme}
                              >
                                {badge.text}
                              </Badge>
                            ))}
                          </HStack>
                        </CardBody>
                      </Stack>
                    </Card>
                  </Box>
                ))}
            </SimpleGrid>
          </Stack>
          :<></>}
        </Stack>
      </Container>
    </>
  );
}